import React from 'react';

export const TelemetryLoading: React.FC = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner" />
    </div>
  );
};

export default TelemetryLoading;
